
@switch (columnId) {
  @case (PaymentOrderBy.Amount) {
    <lib-text-table-column>
      {{ element.amount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case ('Token') {
    <lib-text-table-column>
      {{ element.token }}
    </lib-text-table-column>
  }
  @case ('TransactionStatus') {
    <lib-status-chip
      class="group-transaction-statuses"
      [status]="element?.status">
    </lib-status-chip>
  }
  @case (PaymentOrderBy.PayerName) {
    <lib-text-table-column>
      {{ getDisplayTextForPayerName() }}
    </lib-text-table-column>
  }
  @case ('DigitalWallet') {
    <lib-digital-wallet-image-table-column
      [kind]="element.digitalWallet">
    </lib-digital-wallet-image-table-column>
  }
  @case ('CardBrand') {
    @if (element.card?.cardBrand) {
      <span class="card-image">
        <i [class]="'fab fa-cc-' + element.card.cardBrand.toLowerCase() + ' fa-2x'"></i>
      </span>
    }
    @if (!element.card?.cardBrand) {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case (PaymentOrderBy.CardNumber) {
    <lib-text-table-column>
      {{ getDisplayTextForCardNumber() }}
    </lib-text-table-column>
  }
  @case ('DisputeType') {
    @if (element.disputeTypes?.length) {
      @for (type of element.disputeTypes; track type) {
        <lib-vitu-tooltip [text]="type" position="above" [showDelayInMillis]="0">
          <div class="icon" (mousedown)="onMouseDownDisputeType($event, type)">
            @switch (type) {
              @case (DisputeTypeEnum.Chargeback) {
                <span class="fa-stack">
                  <i class="fas fa-history fa-stack-2x"></i>
                  <div class="dispute-type-chargeback-icon-mask"></div>
                  <i class="far fa-dollar-sign fa-stack-1x"></i>
                </span>
              }
              @case (DisputeTypeEnum.Retrieval) {
                <i class="fas fa-hand-holding-usd fa-2x"></i>
              }
            }
          </div>
        </lib-vitu-tooltip>
      }
    } @else {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case (PaymentOrderBy.DateAndTime) {
    <lib-date-time-label [dateUtc]="element.dateUtc"></lib-date-time-label>
  }
  @case ('Fees') {
    <lib-text-table-column>
      {{ element.fees | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @default {
  }
}





